import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';

interface ResendOwnerInvitationDialogProps {
  open: boolean;
  email: string;
  organisationName: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ResendOwnerInvitationDialog: React.FC<
  ResendOwnerInvitationDialogProps
> = ({ open, email, organisationName, isLoading, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="resend-owner-invitation-dialog-title"
      aria-describedby="resend-owner-invitation-dialog-description"
    >
      <DialogTitle id="resend-owner-invitation-dialog-title">
        Resend owner invitation?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="resend-owner-invitation-dialog-description">
          <strong>{email}</strong> will receive a new invite link for{' '}
          <strong>{organisationName}</strong>, valid for 2 days. The previous
          link will stop working immediately.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          data-testid="confirm-resend-owner-invitation-button"
        >
          {isLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Sending...
            </>
          ) : (
            'Resend invitation'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
